export default __webpack_public_path__ + "static/softwax-ab8d7dd64ea67a52a599a13067609ce4.png";